module.exports = __webpack_public_path__ + "media/images/ecobanqc-a9de750965606fb2b4f17fcf6fd828c0.png";